import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { getCustomIcon } from './landingConstants';

export function CustomizationSection({ content, theme, t }) {
  if (!content.customization) return null;

  const features = content.customization.features || [];
  const remainder = features.length % 4;
  const fullRowEnd = remainder === 0 ? features.length : features.length - remainder;
  const fullRowItems = features.slice(0, fullRowEnd);
  const lastRowItems = remainder === 0 ? [] : features.slice(fullRowEnd);
  const lastRowCols = remainder === 1 ? 'sm:grid-cols-1 lg:grid-cols-1' : remainder === 2 ? 'sm:grid-cols-2 lg:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-3';
  const fullRowOdd = fullRowItems.length % 2 !== 0;
  const lastRowTabletOdd = lastRowItems.length % 2 !== 0 && lastRowItems.length > 1;

  const renderCard = (item, index, spanTablet = false) => (
    <Card key={index} className={`${theme === 'dark' ? 'bg-gray-700/60 border-gray-600' : 'bg-gray-50 border-gray-200 shadow-sm'} ${t.cardHover} transition-all ${spanTablet ? 'sm:col-span-2 lg:col-span-1' : ''}`}>
      <CardContent className="p-6 text-center">
        <div className={`w-14 h-14 rounded-full ${theme === 'dark' ? 'bg-[#007a33]/20' : 'bg-[#007a33]/10'} flex items-center justify-center mx-auto mb-4 ${t.accentText}`}>
          {getCustomIcon(item.icon)}
        </div>
        <h3 className={`font-semibold ${t.text} mb-2`}>{item.title}</h3>
        <p className={`${t.textSecondary} text-sm`}>{item.description}</p>
      </CardContent>
    </Card>
  );

  return (
    <section key="customization" id="customization" data-section="customization" className="relative pt-20 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          {content.customization.badge && (
            <Badge className="bg-[#007a33] text-white border-[#007a33] mb-4 px-4 py-1 hover:bg-[#007a33] text-[0.7rem] font-black tracking-[1px]">
              {content.customization.badge}
            </Badge>
          )}
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">{content.customization.title}</h2>
          <p className={`${t.textSecondary} text-lg`}>{content.customization.subtitle}</p>
        </div>
        {fullRowItems.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {fullRowItems.map((item, i) => renderCard(item, i, fullRowOdd && i === fullRowItems.length - 1))}
          </div>
        )}
        {lastRowItems.length > 0 && (
          <div className={`grid grid-cols-1 ${lastRowCols} gap-6 ${fullRowItems.length > 0 ? 'mt-6' : ''} max-w-5xl mx-auto`}>
            {lastRowItems.map((item, i) => renderCard(item, fullRowEnd + i, lastRowTabletOdd && i === lastRowItems.length - 1))}
          </div>
        )}
        {content.customization.footerText && (
          <p className={`text-center text-sm ${t.textMuted} mt-8`}>{content.customization.footerText}</p>
        )}
      </div>
    </section>
  );
}
